import { render, staticRenderFns } from "./section-contacto.vue?vue&type=template&id=06e98360&scoped=true"
import script from "./section-contacto.vue?vue&type=script&lang=js"
export * from "./section-contacto.vue?vue&type=script&lang=js"
import style0 from "./section-contacto.vue?vue&type=style&index=0&id=06e98360&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e98360",
  null
  
)

export default component.exports